import { Suspense } from 'react';
import ErrorBoundary from '@/components/shared/ErrorBoundary';

/** Wrap a lazy-loaded component in Suspense with error boundary */
export const withSuspense = (Component: React.ElementType, fallback?: React.ReactNode) => (
  <ErrorBoundary>
    <Suspense fallback={fallback || null}>
      <Component />
    </Suspense>
  </ErrorBoundary>
);
